module.exports = __webpack_public_path__ + "img/mj8-infiltration.03fcfc2e.png";